export default __webpack_public_path__ + "static/media/trailer_3_3.c53e3ed9.svg";